/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
import React, { FC, useEffect } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeader from '@/components/modules/SectionHeader'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Checkbox from '@/components/elements/Checkbox'
import Button from '@/components/elements/Button'
import Input from '@/components/elements/Input'
import Label from '@/components/elements/Label'
import Form, { useForm } from 'rc-field-form'
import { ValidationError } from '@formspree/react'
import Link from 'next/link'
import ContactSocial from '@/components/modules/ContactSocial'
import Swal from 'sweetalert2'
import TextArea from '@/components/elements/TextArea'
import { regexNameWithSpecial, phoneRegexThai } from '@/enum/regexp'

const ContactPage: FC = () => {
  const [form] = useForm()

  useEffect(() => {
    const animateButton = (e: { preventDefault: () => void; currentTarget: any }) => {
      e.preventDefault()
      const target = e.currentTarget

      const handleTransitionEnd = () => {
        // Remove the event listener to avoid multiple triggers
        target.removeEventListener('animationend', handleTransitionEnd)

        // Your custom onClick logic goes here
        console.log('Button clicked!')
        onFinish()
      }

      // Add a class to start the bubbly animation
      target.classList.add('animate')

      // Listen for the end of the animation
      target.addEventListener('animationend', handleTransitionEnd)
    }

    const buttons = document.querySelectorAll('.btn-bubbly')
    buttons.forEach((button) => {
      button.addEventListener('click', animateButton)
    })

    return () => {
      buttons.forEach((button) => {
        button.removeEventListener('click', animateButton)
      })
    }
  }, [])

  const onFinish = () => {
    form.validateFields().then(async (values) => {
      await fetch(`https://formspree.io/f/${process.env.FORMSPREE_KEY}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: process.env.FORMSPREE_KEY,
          _from_name: values._from_name,
          name: values.name,
          phone: values.phone,
          email: values.email,
          company: values.company,
          subject: values.subject,
          message: values.message,
        }),
      })
        .then((res) => {
          res.json()
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Your message has been sent.',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            form.resetFields()
          })
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            timer: 1500,
          }).then(() => {
            form.resetFields()
          })
        })
    })
  }
  return (
    <LayoutDefault image='https://twinsynergy.co.th/images/social-contact.webp'>
      <SectionHeader
        title='contact'
        bgColors='#1990FF'
        bgImage='/images/default_banner_header.webp'
        bgImageSm='/images/default_banner_header-sm.webp'
        bgImageWidth={1214}
        bgImageHeight={534}
      />
      <div className='container mx-auto px-4 pb-16 pt-32'>
        <div className='my-6 grid grid-flow-row grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-4 lg:gap-8'>
          <div className=''>
            <ImgResponsive src='/images/contact.webp' alt='Cotact Us' loadingLazy />
            <ContactSocial />
          </div>
          <div className='pt-16 lg:px-8 lg:pt-0'>
            <Form className='space-y-4' form={form} onFinish={onFinish}>
              <input type='hidden' name='_from_name' value='Twin Synergy' />
              <input type='hidden' name='_name' value='Twin Synergy' />
              <Label
                name='name'
                label='Name'
                rules={[
                  { required: true, message: 'Please input your name!' },
                  {
                    pattern: regexNameWithSpecial,
                    message: 'Wrong format!',
                  },
                ]}
              >
                <Input type='text' name='name' className='input-primary w-full' />
              </Label>
              <Label
                name='phone'
                label='Phone no.'
                rules={[
                  { required: true, message: 'Please input your phone!' },
                  {
                    pattern: phoneRegexThai,
                    message: 'Format wrong!',
                  },
                ]}
              >
                <Input
                  type='text'
                  name='phone'
                  placeholder='0886559393'
                  className='input-primary w-full'
                />
              </Label>
              <Label
                name='email'
                label='Email'
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'The input is not valid E-mail!' },
                ]}
              >
                <Input type='email' name='email' className='input-primary w-full' />
              </Label>
              <Label name='company' label='Company name'>
                <Input type='text' name='company' className='input-primary w-full' />
              </Label>
              <Label
                name='subject'
                label='Job title'
                rules={[{ required: true, message: 'Please input your job title!' }]}
              >
                <Input type='text' name='subject' className='input-primary w-full' />
              </Label>
              <Label
                name='message'
                label='Message'
                rules={[{ required: true, message: 'Please input your message!' }]}
              >
                <TextArea name='message' className='input-primary w-full' />
              </Label>
              <Label
                labelHidden
                label='privacy'
                name='privacy'
                rules={[{ required: true, message: 'Please accept the terms and conditions!' }]}
              >
                <div className='flex'>
                  <Checkbox name='privacy' label='I have read and agree to the website' />
                  <Link className='ml-1 text-primary' href='/terms-and-conditions'>
                    terms and conditions
                  </Link>
                </div>
              </Label>
              <ValidationError
                prefix='privacy'
                field='privacy'
                className='text-error'
                errors={null}
              />
              <div className='pt-10'>
                <Button isBubbly className='btn-primary my-4 px-8' htmlType='submit'>
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ContactPage
